import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.5 12h-5m14.75 0H14.5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M14.25 12a2.25 2.25 0 11-4.502-.002A2.25 2.25 0 0114.25 12z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 21v-3.75H21M9.349 21.977l2.65-2.65 2.653 2.65M6.75 21v-3.75H3M6.75 3v3.75H3M17.25 3v3.75H21"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M9.349 21.974l2.65-2.651 2.653 2.65m-.001-19.947l-2.65 2.651-2.653-2.65M2.026 9.349l2.651 2.65-2.65 2.653m19.947-.001l-2.651-2.65 2.65-2.653m-11.778.972L6.66 6.785m10.43 10.43l-3.358-3.358m-1.857-4.232v-5m0 14.75v-4.75m1.68-4.305l3.535-3.535M6.66 17.215l3.358-3.358"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M19 24H9m29.5 0H29"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M28.5 24c0 2.484-2.016 4.5-4.5 4.5a4.502 4.502 0 01-4.5-4.5c0-2.484 2.016-4.5 4.5-4.5s4.5 2.016 4.5 4.5z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 42v-7.5H42m-23.303 9.455l5.302-5.302 5.304 5.302M13.5 42v-7.5H6M13.5 6v7.5H6M34.5 6v7.5H42"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M18.697 43.947l5.302-5.302 5.304 5.302m0-39.894L24 9.355l-5.304-5.302M4.053 18.697l5.302 5.302-5.302 5.304m39.894 0L38.645 24l5.302-5.304M20.39 20.64l-7.07-7.07m20.86 20.86l-6.716-6.716M23.75 19.25v-10m0 29.5v-9.5m3.36-8.61l7.07-7.07M13.32 34.43l6.716-6.716"
  }))
};
export var WeatherSnow = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});